import type { NextPage } from "next";

const availableDate = process.env.NEXT_PUBLIC_MAINTENANCE_AVAILABLE_DATE;

const Maintenance: NextPage = () => {
  return (
    <div className="container-wrapper">
      <div className="login-container">
        <div className="fill-half">
          <img
            className="push-double--top"
            height="175px"
            src="/img/ftl-logo.png"
            alt="Food Truck League"
          />
        </div>
        <div className="fill-half">
          <h1>Scheduling Temporarily Unavailable</h1>
          <p>
            Truck scheduling is temporarily unavailable. Please check back soon.
          </p>
          {availableDate && (
            <p className="push--top">
              Estimated availability: <strong>{availableDate}</strong>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
